import { render, staticRenderFns } from "./DrinkCards.vue?vue&type=template&id=66456b4a&scoped=true"
import script from "./DrinkCards.vue?vue&type=script&lang=js"
export * from "./DrinkCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66456b4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66456b4a')) {
      api.createRecord('66456b4a', component.options)
    } else {
      api.reload('66456b4a', component.options)
    }
    module.hot.accept("./DrinkCards.vue?vue&type=template&id=66456b4a&scoped=true", function () {
      api.rerender('66456b4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DrinkCards.vue"
export default component.exports